<div class="wrap">
  <div
    *ngIf="(scannerService.hasCameraPermission | async) === false"
    class="no-permission"
  >
    {{ "@pages.scanner.noPermissionMessage" | translate }}
  </div>

  <div *ngIf="loader.isLoading$ | async" class="app-spinner-container">
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>

  <div class="content">
    <div class="top">
      <div
        class="hint-wrapper"
        *ngIf="
          pageState === pageStates.PRODUCT_SCANNING ||
          pageState === pageStates.PRODUCT_SCANNING_ERROR
        "
      >
        <ng-container
          *ngTemplateOutlet="hintTemplate; context: { type: 'barcode' }"
        ></ng-container>
      </div>
    </div>

    <div class="center">
      <div class="scanner-container">
        <app-scanner
          [appHidden]="(scannerService.hasCameraPermission | async) === false"
        ></app-scanner>
      </div>
    </div>
    <div class="bottom">
      <div
        class="hint-wrapper"
        *ngIf="
          pageState === pageStates.LOCATION_AUTH ||
          pageState === pageStates.LOCATION_AUTH_ERROR
        "
      >
        <ng-container
          *ngTemplateOutlet="hintTemplate; context: { type: 'location' }"
        ></ng-container>
      </div>
      <div
        class="product-scanning-buttons"
        *ngIf="pageState === pageStates.PRODUCT_SCANNING"
      >
        <div class="btn" (click)="onManualBarcodeInputClick()">
          {{ "@pages.scanner.actions.manualInput" | translate }}
        </div>
        <div class="btn" (click)="onProductSearchClick()">
          {{ "@pages.scanner.actions.search" | translate }}
        </div>
      </div>
    </div>
  </div>
  <!-- <div *ngIf="isDebug" class="debug-message">{{ debugMessage }}</div> -->
</div>

<ng-template #hintTemplate let-type>
  <div
    *ngIf="
      scannerService.isRan &&
      (scannerService.hasCameraPermission | async) !== false
    "
    class="hint-container {{ type }}"
    [class.error]="
      pageState === pageStates.LOCATION_AUTH_ERROR ||
      pageState === pageStates.PRODUCT_SCANNING_ERROR
    "
  >
    <div class="top">
      <img
        *ngIf="
          pageState !== pageStates.LOCATION_AUTH_ERROR &&
          pageState !== pageStates.PRODUCT_SCANNING_ERROR
        "
        class="illustration"
        src="assets/illustrations/{{
          pageState === pageStates.LOCATION_AUTH
            ? 'store-mono.svg'
            : 'barcode-mono.svg'
        }}"
        alt="picture"
      />
      <div
        *ngIf="
          pageState !== pageStates.LOCATION_AUTH_ERROR &&
          pageState !== pageStates.PRODUCT_SCANNING_ERROR
        "
        class="hint"
      >
        {{ "@pages.scanner.hints." + pageState | translate }}
      </div>
      <div
        *ngIf="
          pageState === pageStates.LOCATION_AUTH_ERROR ||
          pageState === pageStates.PRODUCT_SCANNING_ERROR
        "
        class="hint"
      >
        {{ "@pages.scanner.hints." + scanErrorType | translate }}
      </div>
    </div>
  </div>
</ng-template>
